import React from 'react';
import { cardSurfaceClass, cx, insightToneClasses } from '../theme';

export default function InsightCard({ insight }) {
  const tone = insightToneClasses[insight.tone] || insightToneClasses.critical;

  return (
    <article data-coo="insight-card" className={cx(cardSurfaceClass, 'border-t-4 p-5', tone.border)}>
      <h3 data-coo="insight-title" className="text-[14px] font-bold text-slate-800">
        {insight.title}
      </h3>
      <div data-coo="insight-exposure" className={cx('mt-2 text-[12px] font-bold', tone.exposure)}>
        {insight.exposure}
      </div>
      <div data-coo="insight-body" className="mt-3 text-[13px] leading-[1.65] text-slate-600">
        {insight.body}
      </div>
      <div className="mt-4 rounded-xl border-l-[3px] border-accent bg-slate-50 px-4 py-3 text-[12px] leading-[1.6] text-slate-700">
        <strong data-coo="insight-action-label" className="block text-[11px] font-semibold text-slate-700">
          {insight.actionLabel}
        </strong>
        <span data-coo="insight-action-text">{insight.actionText}</span>
      </div>
    </article>
  );
}
